export const SET_WIDGET_DATA = 'SET_WIDGET_DATA';
export const SET_VEHICLE_DATA = 'SET_VEHICLE_DATA';
